import React, { useState, useEffect } from "react";
import Card from "./Card";
import { X, BadgeCent, Volume2 } from "lucide-react";
import logo from "../assets/logo3.png";

// Updated PricingModal that doesn't need payment processing anymore
const PricingModal = ({ onClose }) => {
  const [selectedPrice, setSelectedPrice] = useState(350);
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile viewport on component mount
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    // Initial check
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100000] p-1 overflow-y-auto">
      <div className="relative bg-black text-[#EAECEF] shadow-lg rounded-2xl p-2 sm:p-6 w-full max-w-4xl md:w-[70%] border border-[#3A3D3E] flex flex-col items-center max-h-[90vh] sm:max-h-[95vh] overflow-y-auto">

        {/* Close Button - positioned to be always visible */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-white hover:text-gray-300 transition bg-[#1F2123] p-1.5 sm:p-2 rounded-full z-50 flex items-center justify-center"
          aria-label="Close modal"
          style={{ width: "28px", height: "28px" }}
        >
          <X size={18} strokeWidth={2.5} className="sm:w-6 sm:h-6" />
        </button>

        {/* Logo + Heading */}
        <div className="flex items-center gap-1 sm:gap-2 mt-4 sm:mt-0">
          <img src={logo} alt="Lucid-TTS Logo" className="h-6 w-6 sm:h-10 sm:w-10" />
          <h2 className={`${isMobile ? 'text-base' : 'text-lg sm:text-2xl md:text-3xl'} font-bold text-center`}>
            {isMobile ? 'Introductory Offer 🎉' : 'Lucid-TTS Introductory Offer 🎉'}
          </h2>
        </div>

        <p className={`text-[#B0B4BB] text-center ${isMobile ? 'mt-0.5 text-xs px-0.5' : 'mt-1 sm:mt-3 text-sm sm:text-lg px-1 sm:px-2'}`}>
          Experience premium AI Voices at a fraction of the cost.
        </p>

        {/* Audio Duration Heading - more compact for mobile */}
        <div className={`w-full ${isMobile ? 'mt-1 mb-0' : 'mt-2 sm:mt-5 mb-0 sm:mb-3'}`}>
          <div className="flex items-center justify-center gap-1 sm:gap-3">
            <Volume2 size={isMobile ? 12 : 14} className="sm:w-5 sm:h-5 text-[#178A94]" />
            <h3 className={`${isMobile ? 'text-xs' : 'text-sm sm:text-xl'} font-semibold text-center text-[#EAECEF]`}>
              Select <span className="bg-gradient-to-r from-[#178A94] to-[#20B6C5] bg-clip-text text-transparent">audio</span> duration
            </h3>
          </div>
          <div className={`h-0.5 ${isMobile ? 'w-8' : 'w-12 sm:w-24'} mx-auto ${isMobile ? 'mt-0.5' : 'mt-1 sm:mt-2'} bg-gradient-to-r from-[#178A94] to-[#20B6C5] rounded-full`}></div>
        </div>

        {/* Card Component with container height constraints for mobile */}
        <div className="w-full mt-0 sm:mt-2 bg-transparent p-0 sm:p-4 rounded-lg">
          <Card onRangeChange={setSelectedPrice} />
        </div>
      </div>
    </div>
  );
};

const BuyCreditsButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="w-full">
      <button
        onClick={() => setIsModalOpen(true)}
        className="flex items-center justify-center gap-2
                  px-[0.75rem] py-[0.5rem]
                  w-full
                  bg-gradient-to-b from-[#178A94] to-[#146E75]
                  text-[#EAECEF] font-medium
                  text-[0.875rem]
                  rounded-lg shadow-lg border border-[#178A94]/20
                  backdrop-blur-sm hover:scale-105 transition-all"
      >
        <BadgeCent size={16} /> Buy Credits
      </button>
      {isModalOpen && <PricingModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
};

export { PricingModal, BuyCreditsButton };